<template>
  <HeaderWrapper class="pce-dealerheader" />
</template>

<script>
import HeaderWrapper from "./components/HeaderWrapper.vue";

export default {
  name: "DealerHeaderApp",
  components: {
    HeaderWrapper
  },
  async created() {
    this.$dataLayer.push({ event: "pcedh.loaded" })
  }
};
</script>

<style scoped>
@import "./assets/fonts/stihl-icons/styles.css";
@import "./assets/fonts/Contraface/styles.css";
</style>
<style lang="scss">
.pce-dealerheader {
  font-size: 14px;
  max-height: 36px;
}
@media screen AND (max-width: $breakpoint-md) {
  .pce-dealerheader {
    height: 56px;
    max-height: 56px;
  }
}
</style>
